import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  title: Yup.string().required('Tile is required'),
  export_type: Yup.array().min(1, 'At least one export type is required'),
  export_columns: Yup.array(),
  selected_columns: Yup.array()
});

export default validationSchema;
